<template>
  <ul class="u-breadcrumbs">
    <li v-for="(crumb, cI) in mappedBreadcrumbs" :key="`crumb-${cI}`">
      <component :is="crumb.is" v-bind="crumb.attrs">{{
        crumb.label
      }}</component>
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type { ICrumb } from "@/models/breadcrumbs";

export default defineComponent({
  name: "UBreadcrumbs",
  props: {
    crumbs: { type: Array as PropType<ICrumb[]>, default: () => [] }
  },
  computed: {
    mappedBreadcrumbs() {
      return this.$_.map(this.crumbs, crumb => ({
        ...this.$_.pick(crumb, ["label"]),
        is: crumb.route ? "u-link" : "span",
        attrs: crumb.route ? { ...crumb.route, tag: "router-link" } : null
      }));
    }
  }
});
</script>

<style lang="scss" scoped>
ul.u-breadcrumbs {
  display: block;
  text-transform: uppercase;
  font-size: $size-7;
  li {
    display: inline;
    list-style: none;
    &,
    & > a {
      color: currentColor;
    }
    &:not(:last-child) {
      opacity: 0.5;
    }
    &:not(:last-child):after {
      content: " / ";
    }
    &:last-child {
      font-weight: $weight-semibold;
    }
  }
}
</style>
